import API from './api'
import { ICapture } from '../types'
import { pull, remove, find } from 'lodash'

const TICK_INTERVAL = 10000
const WATCH_TIMEOUT = 3600000

const api = new API()

type IWatchingData = {
    uuid: string
    timestamp: number
}
class CaptureWatcher {
    watching: IWatchingData[] = []
    listeners: ((capture: ICapture) => void)[] = []

    constructor() {
        this.loadData()
        setInterval(this.onIntervalTick, TICK_INTERVAL)
    }

    loadData = () => {
        this.watching = JSON.parse(window.sessionStorage.getItem('SUPERCUT_WATCHER') || '[]')
    }

    saveData = () => {
        window.sessionStorage.setItem('SUPERCUT_WATCHER', JSON.stringify(this.watching))
    }

    onIntervalTick = async () => {
        for (const { uuid, timestamp } of this.watching) {
            const now = new Date()
            if (now.getTime() - timestamp > WATCH_TIMEOUT) {
                this.remove(uuid)
            } else {
                try {
                    const { status, capture } = await api.getCaptureStatus(uuid)
                    switch (status.toLowerCase()) {
                        case 'done':
                        case 'error':
                            this.remove(uuid)
                            for (const listener of this.listeners) {
                                listener(capture)
                            }
                            break
                        default:
                            console.log(uuid, 'Watching...')
                            break
                    }
                } catch {}
            }
        }
    }

    addListener = (listener: (capture: ICapture) => void) => {
        this.listeners.push(listener)
    }

    removeListener = (listener: (capture: ICapture) => void) => {
        pull(this.listeners, listener)
    }

    add = (uuid: string) => {
        if (!find(this.watching, (w) => w.uuid === uuid)) {
            const now = new Date()
            this.watching.push({
                uuid: uuid,
                timestamp: now.getTime(),
            })
        }
        this.saveData()
    }

    remove = (uuid: string) => {
        remove(this.watching, (w) => w.uuid === uuid)
        this.saveData()
    }

    clear = () => {
        this.watching = []
        this.saveData()
    }
}

const defaultWatcher = new CaptureWatcher()

export default defaultWatcher
